export default "__VITE_ASSET__Bw0m9MCF__"